export default "__VITE_ASSET__DmelkwgY__"